"use client";

import { useEffect } from "react";
import { trackPublicEvent } from "@/lib/public-analytics";

const eventParameters = {
  product: "marginglow_ai_signal",
  audience: "human",
  page_path: "/signal",
};

export default function SignalPageAnalytics() {
  useEffect(() => {
    trackPublicEvent("signal_page_view", eventParameters);
  }, []);

  return null;
}

export function SignalBetaAccessLink() {
  return (
    <a
      href="/signal/access"
      onClick={() => {
        trackPublicEvent("signal_beta_access_click", {
          ...eventParameters,
          access_stage: "self_service",
        });
      }}
      className="rounded-full bg-[#c63d27] px-7 py-4 text-center font-light text-white shadow-sm"
    >
      Get agent access
    </a>
  );
}
